import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import SubmitButton from '../../../../Components/Button/SubmitButton';
// @ts-ignore
import styles from './CasePermanentMedicationDecline.module.scss';
import apiClient from '../../../../Services/ApiClient';
import { useAppContext } from '../../../../Services/AppContext';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';
import useRestApiClient from '../../../Base/Hooks/useRestApiClient';

interface Props {
	caseId: string;
	onSuccess: () => void;
}

const CasePermanentMedicationDecline: React.FC<Props> = ({
	caseId,
	onSuccess,
}) => {
	const { userData } = useAppContext();
	const { displayError } = useApiClient();
	const { processResult } = useRestApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const validationSchema = yup.object({
		message: yup
			.string()
			.required('component.casePermanentMedicationDecline.youMustFillMessage'),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleOnSubmit = async (values: any) => {
		try {
			const result = await apiClient.put(`/cases/${caseId}/message`, {
				initial: false,
				sender: userData.id,
				text: values.message,
				type: 'm',
			});
			processResult(result, async () => {
				const result2 = await apiClient.put('/cases/' + caseId + '/solve', {
					ignoreSending: false,
				});
				processResult(result2, () => {
					showNotificationSuccess({
						content: t(
							'component.casePermanentMedicationDecline.declineSuccessMessage',
						),
					});
					onSuccess();
				});
			});
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.textWrapper}>
				<Text tx='component.casePermanentMedicationDecline.doYouReallyWishDeclineRequest' />
			</div>
			<div>
				<FormWrapper formMethods={formMethods}>
					<TextAreaField
						name='message'
						label='component.casePermanentMedicationDecline.message'
						isRequired
					/>
					<div className={styles.buttonWrapper}>
						<SubmitButton
							title='component.casePermanentMedicationDecline.sendAndCloseCase'
							onSubmit={handleOnSubmit}
						/>
					</div>
				</FormWrapper>
			</div>
		</div>
	);
};

export default CasePermanentMedicationDecline;
